export default __webpack_public_path__ + "static/oil_collection-71f990b65da97532c6ba52e1cfeb15a0.webp";